
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { Validate } from '@/types';
import PhoneNumberInput from '@/components/shared/PhoneNumberInput.vue';
import TextField from '@/components/shared/TextField.vue';

const namespace: string = 'orders';

@Component<ContactInformation>({
	components: {
		PhoneNumberInput,
		TextField,
		ValidationObserver,
		ValidationProvider
	}
})
export default class ContactInformation extends Vue {
	@Action('setContactInformation', { namespace }) setContactInformation!: (contact: Contact) => void;
	@Getter('getContactInformation', { namespace }) contactInfo!: Contact;
	@Getter('getOrderType', { namespace }) orderType!: string;
	@Getter('isQuoting', { namespace }) private isQuoting!: boolean;
	@Getter('getContactFieldsConfig', { namespace: 'auth' }) contactFieldsConfig!: ContactFieldsConfig;
	@Getter('getSelectedInquiryFormRequest', { namespace: 'inquiryForm' }) private request!: InquiryFormRequest;
	@Prop({ type: Boolean, default: false }) private hideHeader!: boolean;

	$refs!: { observer: Validate; };

	private contact: Contact = {
		full_name: '',
		email: '',
		phone_number: ''
	};

	private created(): void {
		if (Object.values(this.contactInfo).some(Boolean)) {
			this.contact = this.contactInfo;
		}
		else if (this.request && this.isQuoting) {
			this.contact = {
				full_name: this.request.name,
				email: this.request.email,
				phone_number: this.request.phone_number
			};
		}
		this.setContactInformation(this.contact);
	}

	/**
	 * Update the phone number with the normalized value emitted by the input
	 *
	 * @param {string} value
	 * @return {void}
	 */
	private onPhoneInput(value: string): void {
		this.contact.phone_number = value;
		this.setContactInformation(this.contact);
	}
}
